import React, { useEffect, useState } from 'react'
import { Link, } from 'react-router-dom';
import { Button, ProgressBar } from 'react-bootstrap';
import { AppLogger } from '../../services/AppLogger';
import { default as ReactSelect } from "react-select";
import { AppConstant, showErrorToast, showSuccessToast } from '../../services/AppConstant';
import Navigation from '../../components/navbar/Navigation';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Sidebar from '../../components/sidebar/Sidebar';
import FBServices from "../../services/unit.services"
import AppRoutes from '../../services/AppRoutes';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../App.css';
import { get } from 'lodash';

function NotifyUsers({ }) {
    const [listOfUsers, setListOfUsers] = useState([]);
    const [notifyBody, setNotifyBody] = useState({
        title: "",
        body: "",
    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [progressStats, setProgressStats] = useState({
        total: 0,
        completed: 0,
        success: 0,
        failed: 0,
        percentage: 0
    });

    useEffect(() => {
        getUsersForNotification();
        AppLogger("getUsersForNotification", "called")
    }, [])

    const getUsersForNotification = async () => {
        var dummyList = []
        const data = await FBServices.getNotificationUsers();
        AppLogger("getUsersForNotification", "fetched users data")
        data.docs.map((doc) => {
            AppLogger("user details", doc.data())
            if (doc.data().fcmToken && doc.data().fcmToken.trim() !== "" &&
                doc.data().country && doc.data().country.trim() !== "") {
                dummyList.push({
                    value: doc.data().fcmToken,
                    label: doc.data().fullName,
                    userId: doc.id // Store user ID for database storage
                })
            }
        })
        setListOfUsers(dummyList)
        AppLogger("getUsersForNotification", `${dummyList.length} users loaded`)
    };

    // Save notification to Firestore
    const saveNotificationToDb = async (receiverIds, isForAll) => {
        try {
            AppLogger("saveNotificationToDb", "started")
            AppLogger("saveNotificationToDb", `receiverIds: ${JSON.stringify(receiverIds)}, isForAll: ${isForAll}`)

            const notification = {
                title: notifyBody.title,
                body: notifyBody.body,
                senderID: "admin", // Assuming admin is sending the notification
                receiverIDs: receiverIds,
                forAll: isForAll,
                type: "push_notification",
                createdAt: Date.now(),
                isRead: false
            };

            const result = await FBServices.addNotification(notification);
            AppLogger("saveNotificationToDb", "notification saved successfully", result)
            return true;
        } catch (error) {
            AppLogger("saveNotificationToDb", "error saving notification", error)
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        AppLogger("handleSubmit", "started")

        // Check if "All" option is selected
        const isAllSelected = selectedOptions.find(item => item.label === "All") !== undefined;

        // Extract user IDs for database storage
        const receiverIds = isAllSelected ? [] : selectedOptions.map(option => option.userId).filter(id => id);

        // Filter out the "All" option for FCM notifications
        const usersToNotify = selectedOptions.filter(option => option.value !== "*");
        const totalUsers = usersToNotify.length;

        AppLogger("handleSubmit", `Total users to notify: ${totalUsers}`)

        // Initialize progress state
        setIsSubmitting(true);
        setProgressStats({
            total: totalUsers,
            completed: 0,
            success: 0,
            failed: 0,
            percentage: 0
        });

        AppLogger("handleSubmit", "Saving notification to database first")

        // Save notification to database first
        const dbSaveResult = await saveNotificationToDb(receiverIds, isAllSelected);
        AppLogger("handleSubmit", `Database save result: ${dbSaveResult}`)

        if (!dbSaveResult) {
            showErrorToast("Failed to save the notification to database.");
            setIsSubmitting(false);
            return;
        }

        // Send FCM notifications after database save
        AppLogger("handleSubmit", "Database save successful, now sending push notifications")

        if (totalUsers > 0) {
            for (let index = 0; index < usersToNotify.length; index++) {
                const element = usersToNotify[index];
                AppLogger("handleSubmit", `sending notification to ${element.label}`)

                try {
                    const response = await fetch(
                        AppConstant.FirebaseNotiAPIPath,
                        {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${AppConstant.FCM_SERVER_KEY}`
                            },
                            body: JSON.stringify({
                                deviceToken: [get(element, "value", "")],
                                notificationTitle: notifyBody.title,
                                notificationBody: notifyBody.body,
                            })
                        });

                    const data = await response.json();
                    AppLogger("data fcm send notification", data)

                    // Update progress stats
                    setProgressStats(prevStats => {
                        const completed = prevStats.completed + 1;
                        const success = get(data, "status", "") !== "error" ? prevStats.success + 1 : prevStats.success;
                        const failed = get(data, "status", "") === "error" ? prevStats.failed + 1 : prevStats.failed;
                        const percentage = (completed / totalUsers) * 100;

                        return {
                            total: totalUsers,
                            completed,
                            success,
                            failed,
                            percentage
                        };
                    });

                    if (get(data, "status", "") === "error") {
                        AppLogger("handleSubmit", `Failed to send notification to ${element.label}`, data)
                    }
                } catch (error) {
                    // Update progress stats on error
                    setProgressStats(prevStats => {
                        const completed = prevStats.completed + 1;
                        const failed = prevStats.failed + 1;
                        const percentage = (completed / totalUsers) * 100;

                        return {
                            total: totalUsers,
                            completed,
                            success: prevStats.success,
                            failed,
                            percentage
                        };
                    });

                    AppLogger("error fcm send notification", error)
                }
            }
        } else if (isAllSelected) {
            // If "All" was selected but we don't have FCM tokens to send to,
            // mark as complete with 100% for the progress bar
            setProgressStats({
                total: 1,
                completed: 1,
                success: 1,
                failed: 0,
                percentage: 100
            });
        }

        // Clear the form after processing
        setSelectedOptions([])
        setNotifyBody({
            title: "",
            body: "",
        })

        // Show success toast with FCM results
        if (progressStats.failed > 0) {
            showSuccessToast(`Notifications sent successfully to ${progressStats.success} users with ${progressStats.failed} failures.`);
        } else if (progressStats.success > 0) {
            showSuccessToast(`Notifications sent successfully to all ${progressStats.success} users.`);
        } else {
            showSuccessToast("Notification saved successfully.");
        }

        // Reset submission state
        setIsSubmitting(false);
    }

    const selectAllOption = { label: 'Select All', value: '*' };

    const handleChange = (newSelectedOptions, actionMeta) => {
        var allSelected = false
        AppLogger("handleChange", `action: ${actionMeta.action}`)

        if (actionMeta.action == "select-option") {
            allSelected = actionMeta.option.label == "All"
            setSelectedOptions(
                allSelected ?
                    [{ label: "All", value: "*" }, ...listOfUsers]
                    : newSelectedOptions
            )
        } else if (actionMeta.action == "remove-value" || actionMeta.action == "deselect-option") {
            var key = ""
            key = actionMeta.action == "remove-value" ? "removedValue" : "option"
            allSelected = actionMeta[key].label == "All"
            setSelectedOptions(
                allSelected ? [] : newSelectedOptions
            )
        } else if (actionMeta.action == "clear") {
            setSelectedOptions([])
        }

        AppLogger("handleChange", `selectedOptions updated: ${newSelectedOptions.length} items`)
    }

    const customStyles = {
        control: base => ({
            ...base,
            height: 80,
            minHeight: 35,
            overflowX: "hidden",
        })
    };

    // Get progress bar variant based on current success/failure ratio
    const getProgressVariant = () => {
        if (progressStats.failed === 0) return "success";
        if (progressStats.failed <= progressStats.success / 5) return "info";
        if (progressStats.failed <= progressStats.success / 2) return "warning";
        return "danger";
    }

    return (
        <>
            <div style={{}} className='side-wrp'>
                <Sidebar />
            </div>
            <Navigation
                originalList={[]}
                updatedList={() => { }}
                searchKey={""}
                showSearh={false}
                setSearchQuery={(val) => null}
            />
            <Row className='full-height'>

                <Col className='white-bg'>
                    <Link className='back-btn override' to={AppRoutes.home}><ArrowBackIcon /> Back to Dashboard </Link>
                    <div className="greet-text">
                        <h2>Send Push Notifications</h2>

                    </div>
                    <Row>
                        <Col>
                            <div className='charts '>
                                <Row>
                                    <Col style={{ height: "50px", marginBottom: "44px" }}>
                                        <ReactSelect
                                            styles={customStyles}
                                            options={[{ label: "All", value: "*" }, ...listOfUsers]}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            onChange={(e, actionMeta) => handleChange(e, actionMeta)}
                                            allowSelectAll={true}
                                            value={selectedOptions}
                                            placeholder={"Select Users"}
                                            required
                                            isDisabled={isSubmitting}
                                        />
                                    </Col>
                                </Row>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="formBasicSerial">
                                                <Form.Control type="text"
                                                    required
                                                    placeholder='Title' fullWidth
                                                    label="Title" id="title"
                                                    value={notifyBody.title}
                                                    onChange={(e) => setNotifyBody({ ...notifyBody, title: e.target.value })}
                                                    disabled={isSubmitting}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="formBasicSerial">
                                                <Form.Control as="textarea" rows={6}
                                                    required
                                                    placeholder='Body' fullWidth
                                                    label="Body" id="body"
                                                    value={notifyBody.body}
                                                    onChange={(e) => setNotifyBody({ ...notifyBody, body: e.target.value })}
                                                    disabled={isSubmitting}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* Progress bar section - visible only when submitting */}
                                    {isSubmitting && (
                                        <Row className="mb-3">
                                            <Col>
                                                <div className="mb-2 d-flex justify-content-between">
                                                    <span>Sending notifications... ({progressStats.completed}/{progressStats.total})</span>
                                                </div>
                                                <ProgressBar
                                                    now={progressStats.percentage}
                                                    variant={getProgressVariant()}
                                                    label={`${Math.round(progressStats.percentage)}%`}
                                                    animated
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    <Row>
                                        <Col className='btn-align'>
                                            <Button
                                                variant="primary"
                                                type='submit'
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Sending...' : 'Send'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default NotifyUsers